import React, { lazy, Suspense } from 'react'
import getMovieTitle from '../../functions/getMovieTitle'
import { BackgroundFormatItemLoading, PosterFormatItemLoading } from '../../SliderStripe/StripeItemLazy'

const GridItemSingle = lazy(() => import('./GridItemSingle'))


const GridItemSingleLoading = ({
    styles,
    title
}) => (
    <div className="order-wrapper" style={styles}>
        <PosterFormatItemLoading
            title={title}
        />
    </div>
)


const GridItemSingleLoadingArthouse = ({
    styles,
    title
}) => (
    <div className="order-wrapper" style={styles}>
        <div className="slide-item">
            <BackgroundFormatItemLoading
                title={title}
            />
        </div>
    </div>
)



const GridItemSingleLazy = (props) => {
    const currentTitle = getMovieTitle(props.itemData)
    let ItemLoading

    if(props.theme === 'Arthouse') {
        ItemLoading = props.isMobile && !props.isSlider ? GridItemSingleLoading : GridItemSingleLoadingArthouse
    } else {
        ItemLoading = GridItemSingleLoading
    }

    return (
        <Suspense fallback={<ItemLoading styles={props.styles} title={currentTitle} />}>
            <GridItemSingle
                {...props}
            />
        </Suspense>
    )
}

export default GridItemSingleLazy